export default __webpack_public_path__ + "static/media/Chimdindu Chukwuka Certificates.41c3370b.pdf";